// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/guild_tag/components/GuildTagBadge.module.css';
import {GUILD_TAG_BADGE_ART} from '@app/features/guild_tag/components/GuildTagBadgeArt.generated';
import {decodeGuildTagBadge, GUILD_TAG_BADGE_COLORS} from '@fluxer/constants/src/GuildTagConstants';
import {clsx} from 'clsx';
import type React from 'react';

interface GuildTagBadgeProps {
	badge: number;
	className?: string;
	'data-flx'?: string;
}

// Plain markup: it sits in message, member and voice rows, so no tooltip, timer, filter or layout read. Every row points
// at the one sprite, and its tones come from the colour on this element.
export function GuildTagBadge({badge, className, 'data-flx': dataFlx}: GuildTagBadgeProps): React.ReactElement {
	return (
		<svg
			aria-hidden={true}
			className={clsx(styles.badge, styles.tones, className)}
			data-color={badge % GUILD_TAG_BADGE_COLORS.length}
			data-flx={dataFlx ?? 'guild-tag.guild-tag-badge.svg'}
		>
			<use href={`#guild-tag-badge-${decodeGuildTagBadge(badge).icon}`} />
		</svg>
	);
}

// The sprite is inline because a <use> cannot reach a file on the static host, which is another origin. Mounted once
// per document, next to SVGMasks.
export function GuildTagBadgeSprite(): React.ReactElement {
	return (
		<svg
			aria-hidden={true}
			className={styles.sprite}
			dangerouslySetInnerHTML={{__html: GUILD_TAG_BADGE_ART}}
			data-flx="guild-tag.guild-tag-badge-sprite.svg"
		/>
	);
}
